export default __webpack_public_path__ + "static/media/emailme.0baa324f.svg";